import axios from "axios";
import { useEffect, useState } from "react";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { BackButton, CancelButton, CreateButton, EditButton, NotificationButton, SubmitButton } from "../../../Components/Utils/Buttons";
import NuPills from "../../../Components/Utils/Nupills";
import DecryptData from "../../../Components/Utils/Decrypt";
import axiosInstance from "../../../Services/axiosCommon";
import { NuInput, NuInputSetting, SupplierNuInput } from "../../../Components/Utils/Input";
import CustomImgUpload from "../../../Components/Utils/CustomImgUpload";
import { useFormik } from "formik";
import socketAxiosInstance from "../../../Services/socketAxiosCommon";
import { useToast } from "../../../Components/Others/ToastServices";
import * as yup from 'yup';
import EditIcon from "../../../Components/Icons/Edit";
import CustomImgUploadSquare from "../../../Components/Utils/CustomImgUploadSquare";
import Email from "../../../Components/Icons/Email";
import { Briefcase, Mail, MailCheck, Mails, Phone, User } from "lucide-react";

function UserProfile() {
  const navigate = useNavigate();
  const toast = useToast();
  const userDetails = DecryptData("sLiAtEdReSuEdArT")||"";
console.log(userDetails,'khgh');
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [user, setUser] = useState({});
  const [userEmailDetails,setUserEmailDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('image');
  const [openEdit,setOpenEdit] = useState(false);
  console.log("search",userEmailDetails?.senderEmail);
  const [createNew, setCreateNew] = useState({
    senderEmail: "",
    password: "",
    signature: "" 
  });

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const handleDeleteImg = () => {
    setImage({
      preview: "",
      raw: "",
    });
    setCreateNew(prevState => ({ ...createNew, signature :"" }))
    formik.values.signature = ''
  }

  const getUserDetails = async () => {
    try {
      const res = await axiosInstance.get(`/user/user-details/${userDetails?.id}`); 
            setUser(res?.data?.data || {});
    } catch (error) {
      console.error(error);
    }
  };

  const getUserEmailDetails = async () => {
    try {
      const res = await axiosInstance.get(`/user/${userDetails?.id}/email-details`); 
      console.log("finding",res?.data?.data);
            setUserEmailDetails(res?.data?.data || {});
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validationSchema:yup.object({

    }),
    onSubmit: async (values, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(values));
      formData.append("signature", image.raw);
      axiosInstance.put(`/user/edit-email-details/${userDetails?.id}`, formData)
        .then((res) => {
          if (res.data.status) {
            resetForm();
            toast.open({
              type: "success",
              message: "Sender Email reset successfully",
              description: res.data?.msg || "Password has been updated.",
            });
          }
          getUserEmailDetails();
          setOpenEdit(false);
        })
        .catch((err) => {
          toast.open({
            type: "error",
            message: "Sender Email reset failed",
            description: err.response?.data?.msg || "Network Error",
          });
        });
    },
  });

  useEffect(() => {
    getUserDetails();
    getUserEmailDetails();
  }, []);

  useEffect(()=>{
    setCreateNew({
      senderEmail: userEmailDetails?.senderEmail,
      password: userEmailDetails?.password,
      signature: userEmailDetails.signature?.file
    })
  },[userEmailDetails])

 
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-between">
        <Breadcrumb items={[{ name: "User Profile" }]} />
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-150px)]">
        <h2 className="text-sm font-semibold text-[#4F4768] p-4 mb-4">
          User Profile View
        </h2>
       <div className="flex flex-col lg:flex-row gap-6 p-6">
  {/* Profile Card */}
  <div className="w-full lg:w-[30%] relative">
    <div className="relative h-80 bg-gradient-to-br from-red-50 to-indigo-50 rounded-2xl shadow-xl overflow-hidden border border-gray-100">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-16 h-16 bg-indigo-100 rounded-full -translate-x-8 -translate-y-8"></div>
      <div className="absolute bottom-0 right-0 w-24 h-24 bg-red-100 rounded-full translate-x-8 translate-y-8"></div>
      
      {/* Profile content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center p-6">
        {/* Avatar with gradient border */}
        <div className="relative mb-6">
          <div className="absolute -inset-2 bg-gradient-to-r from-indigo-400 to-red-500 rounded-full blur-sm opacity-75"></div>
          <div className="relative w-32 h-32 rounded-full bg-white p-1">
            {user.userImage?.file?.length > 0 ? (
              <img
                src={user.userImage?.file}
                alt="user"
                className="rounded-full w-full h-full object-cover border-2 border-white"
              />
            ) : (
              <div className="w-full h-full rounded-full bg-gradient-to-br from-indigo-100 to-red-100 flex items-center justify-center text-indigo-500 text-4xl font-bold">
                {user?.name?.charAt(0)}
              </div>
            )}
          </div>
        </div>
        
        {/* User info */}
        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-800 mb-1">{user?.name || "-"}</h3>
          <p className="text-sm text-gray-600 mb-3">{user?.designation || "-"}</p>
          
          <div className="inline-flex items-center px-4 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-green-100 to-teal-100 text-green-800">
            {user?.status === 1 ? (
              <>
                <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>
                Active
              </>
            ) : (
              <>
                <span className="w-2 h-2 rounded-full bg-gray-400 mr-2"></span>
                Inactive
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Details Card */}
  <div className="w-full lg:w-[40%]">
    <div className="h-80 bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
      {/* Card header */}
      <div className="bg-gradient-to-r from-indigo-500 to-red-600 p-4">
        <div className="flex items-center text-white">
          <User size={20} className="mr-2" />
          <h3 className="text-lg font-semibold">User Details</h3>
        </div>
      </div>
      
      {/* Details content */}
      <div className="p-6 h-[calc(100%-56px)] overflow-y-auto">
        <div className="grid grid-cols-1  gap-6">
          <div className="flex items-start">
            <div className="bg-purple-50 p-2 rounded-lg mr-4">
              <Briefcase size={18} className="text-purple-600" />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 mb-1">Designation</p>
              <p className="text-sm font-medium text-gray-800">
                {user?.designation || "-"}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="bg-indigo-50 p-2 rounded-lg mr-4">
              <Mail size={18} className="text-indigo-600" />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 mb-1">Email</p>
              <p className="text-sm font-medium text-gray-800">
                {user?.email || "-"}
              </p>
            </div>
          </div>
          
         
          <div className="flex items-start">
            <div className="bg-blue-50 p-2 rounded-lg mr-4">
              <Phone size={18} className="text-blue-600" />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 mb-1">Phone</p>
              <p className="text-sm font-medium text-gray-800">
                {user?.phone?.display || "-"}
              </p>
            </div>
          </div>
          
         
         
          
          {/* Add more detail items as needed */}
          {/* <div className="flex items-start">
            <div className="bg-green-50 p-2 rounded-lg mr-4">
              <Building2 size={18} className="text-green-600" />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 mb-1">Division</p>
              <p className="text-sm font-medium text-gray-800">
                {user?.division || "-"}
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  </div>

          {/* <div className="w-[35%]"></div> */}
          {/* <div className="w-[35%] h-96 lg:h-80 bg-white shadow-xl rounded-2xl overflow-y-auto border border-gray-200">
  <div className="w-full p-5">
    <div className="w-full flex justify-between items-center mb-4">
      <h2 className="text-sm font-semibold flex gap-2"><span><MailCheck size={16}/></span> Email Settings</h2>
      <button
        className="p-2 rounded-full bg-sky-100 hover:bg-sky-200 transition"
        onClick={() => setOpenEdit(true)}
      >
        <EditIcon color="skyred" />
      </button>
    </div>

    <div className="space-y-4">
     
      <div>
        <label className="text-xs font-medium text-gray-600 mb-1 block">Sender Email</label>
        <NuInput
          value={userEmailDetails?.senderEmail}
          type="email"
          formik={formik}
          placeholder="Sender Email"
          name="senderEmail"
          width="w-full"
          px="0"
          disabled={true}
        />
      </div>

     
      <div>
        <label className="text-xs font-medium text-gray-600 mb-1 block">Email Password</label>
        <NuInput
          value={userEmailDetails?.password}
          type="password"
          formik={formik}
          placeholder="Password"
          name="password"
          width="w-full"
          px="0"
          disabled={true}
        />
      </div>

    
      <div>
        <label className="text-xs font-medium text-gray-600 mb-2 block">Signature</label>
        <div className="w-full h-24 border border-gray-300 rounded-lg overflow-hidden flex items-center justify-center bg-gray-50">
          {userEmailDetails.signature?.file ? (
            <img
              src={userEmailDetails.signature.file}
              alt="Signature"
              className="object-contain h-full w-full"
            />
          ) : (
            <p className="text-gray-400 text-sm">No Signature Uploaded</p>
          )}
        </div>
      </div>
    </div>
  </div>
</div> */}

        </div>
        <div className="w-full p-4">
          <h2 className="text-sm text-[#4F4768] font-semibold mt-4">
            Settings :
          </h2>
          <div className="w-full flex items-center gap-6 p-4">
            <div className="flex justify-between gap-4 items-center my-2">
              <p className="font-normal text-xs text-[#4F4768]">Profile</p>
              <Link
                to={`/profile/editProfile/${userDetails?.id}`}
                state={{ data: user, from: "/profile" }}
              >
                <EditButton className="text-xs" height={8}>
                  Edit
                </EditButton>
              </Link>
            </div>
            <div className="flex justify-between gap-4 items-center my-2">
              <p className="font-normal text-[#4F4768] text-xs">
                Change Password
              </p>
              <Link to={`/profile/PasswordProfile/${userDetails?.id}`}>
                <CreateButton label="Change" />
              </Link>
            </div>
            {/* <div className="flex justify-between gap-4 items-center my-2">
              <p className="font-normal text-[#4F4768] text-xs">
                Email & Notification
              </p>
              <Link to={`/profile/notificationProfile/${userDetails?.id}`}>
                <NotificationButton
                  className="text-xs"
                  onClick={() => setOpen(true)}
                  label="Change"
                />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      {openEdit && (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[85vh] bg-white rounded-2xl shadow-2xl overflow-y-auto border border-gray-200 p-6">
      
      {/* Modal Header */}
      <div className="flex items-center justify-between border-b pb-3 mb-4">
        <h2 className="text-sm font-semibold text-gray-800">✏️ Edit Email Settings</h2>
        <button
          className="text-gray-500 hover:text-red-500 text-xl font-bold"
          onClick={() => setOpenEdit(false)}
        >
          &times;
        </button>
      </div>
  
      {/* Form */}
      <form onSubmit={formik.handleSubmit} className="space-y-6">
        
        {/* Email Fields */}
        <div className="space-y-4">
          <NuInput
            label="Sender Email"
            type="email"
            formik={formik}
            placeholder="Sender Email"
            name="senderEmail"
            width="w-full"
            px="0"
          />
          <NuInput
            label="Email Password"
            type="password"
            formik={formik}
            placeholder="Password"
            name="password"
            width="w-full"
            px="0"
          />
        </div>
  
        {/* Signature Type Options */}
        <div className="flex items-center justify-between border-t pt-4">
          <p className="text-sm font-medium text-gray-700">Signature Type</p>
          <div className="flex items-center gap-6">
            <label className="flex items-center gap-1 text-sm text-gray-600">
              <input
                type="radio"
                value="text"
                checked={selectedOption === "text"}
                onChange={handleOptionChange}
              />
              Text
            </label>
            <label className="flex items-center gap-1 text-sm text-gray-600">
              <input
                type="radio"
                value="image"
                checked={selectedOption === "image"}
                onChange={handleOptionChange}
              />
              Image
            </label>
          </div>
        </div>
  
        {/* Signature Input */}
        {selectedOption === "text" && (
          <NuInput
            label="Text Signature"
            type="text"
            formik={formik}
            placeholder="Signature Text"
            name="signatureText"
            width="w-full"
            px="0"
          />
        )}
  
        {selectedOption === "image" && (
          <CustomImgUploadSquare
            borderStyle="dashed"
            handleChange={handleChangeImg}
            label={"Signature Image"}
            preview={image.preview || createNew.signature || ""}
            removeFunction={handleDeleteImg}
          />
        )}
  
        {/* Modal Footer */}
        <div className="flex justify-end items-center gap-3 pt-4 border-t">
          <CancelButton
            handleClick={() => setOpenEdit(false)}
          />
          <SubmitButton name="Save" />
        </div>
  
      </form>
    </div>
  </div>
  
      )}
    </div>
  );
}

export default UserProfile;
